import React from "react"
import PageLayout from "../layout/page-layout"
import AboutStyles from "./about.module.scss"

const AboutSection = () => (
  <PageLayout title="About us">
    <div className={AboutStyles.textBlock}>
      <h2>Who are we?</h2>
      <p>
        We are a team of engineers and sale's professionals that created a barbershop management system with the help of some barbers in our personal network.
      </p>
    </div>

    <div className={AboutStyles.textBlock}>
      <h2>Business hours</h2>
      <p>
        <span>Mon - Fri</span> 11am - 8pm
      </p>
      <p>
        <span>Sat</span> 11am - 4pm
      </p>
    </div>

    <div>
      <h2>Where to find us</h2>
      <p>
        1894 Manor Dr. <br />
        Union NJ, 07083
      </p>
    </div>
  </PageLayout>
)

export default AboutSection
